/** Client-side .md helpers for Knowledge article upload (beta). */

export function isMarkdownFilename(name: string): boolean {
  return /\.md$/i.test(name.trim());
}

export function titleFromMarkdownFilename(name: string): string {
  const base = name.replace(/\.md$/i, "").trim();
  return base || "Untitled";
}

export async function readMarkdownFile(file: File): Promise<{ title: string; markdown: string }> {
  if (!isMarkdownFilename(file.name)) {
    throw new Error("Only .md (markdown) files are accepted.");
  }
  const markdown = await file.text();
  return {
    title: titleFromMarkdownFilename(file.name),
    markdown,
  };
}
